import config from '../../appConfig';
import ajax from "services/ajax";

export const sendToES = (data, callback) =>
  ajax(`${config.apiUrl}events`, callback, JSON.stringify(data))

window.ES = {
  sendToES: sendToES
};



// WEBPACK FOOTER //
// ./src/utils/sendToES.js